import { Controller } from "@hotwired/stimulus"

// The section drawer's "N links match" line: fetches the count fragment as
// the query is typed, debounced, and drops answers that arrive out of order.
export default class extends Controller {
  static targets = ["query", "output"]
  static values = { url: String, delay: { type: Number, default: 300 } }

  connect() {
    if (this.queryTarget.value.trim()) this.#fetch()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  refresh() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.#fetch(), this.delayValue)
  }

  async #fetch() {
    const query = this.queryTarget.value.trim()
    const request = (this.latest = Symbol("request"))
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("query", query)
    const response = await fetch(url, { headers: { Accept: "text/html" } })
    // A redirect is the sign-in page, not a count: the session can expire
    // under the open drawer
    if (!response.ok || response.redirected) return
    const html = await response.text()
    // Re-checked after the body arrives: a newer request can overtake this
    // one while the body is still streaming
    if (request !== this.latest) return
    this.outputTarget.innerHTML = html
  }
}
